export default "__VITE_ASSET__nuiQUWLY__"